import {Routes} from "@angular/router";
import {WorkflowPartnerOneTariffComponent} from "./workflow-partner-one-tariff.component";

export const WorkflowPartnerOneTariffRouting: Routes = [
    { path: 'partner/change-tariff/:aid', component: WorkflowPartnerOneTariffComponent, children: [
        { path: 'choose-tariff-variant', component: WorkflowPartnerOneTariffComponent, data: { step: 'choose-tariff-variant' } },
        { path: 'choose-tariff', component: WorkflowPartnerOneTariffComponent, data: { step: 'choose-tariff' } },
        { path: 'delivery-date', component: WorkflowPartnerOneTariffComponent, data: { step: 'delivery-date' } },
        { path: 'contact', component: WorkflowPartnerOneTariffComponent, data: { step: 'contact' } },
        { path: 'invoice-address', component: WorkflowPartnerOneTariffComponent, data: { step: 'invoice-address' } },
        { path: 'payment', component: WorkflowPartnerOneTariffComponent, data: { step: 'payment-method' } },
        { path: 'checkout-summary', component: WorkflowPartnerOneTariffComponent, data: { step: 'checkout-summary' } },
        { path: 'complete', component: WorkflowPartnerOneTariffComponent, data: { step: 'complete' } },
        { path: '', redirectTo: 'choose-tariff-variant', pathMatch: 'full' },
    ]},
]